import React from 'react';

const UserWorkspaceFormModal = React.lazy(() => import('../components/FormModal'));
const userWorkspaceModalRegistry = {
    personalize_userWorkspaceId: UserWorkspaceFormModal
};
export default userWorkspaceModalRegistry;
